// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const passwordInputClasses = {
  visibilityTrigger: "qui-password-input__visibility-trigger",
} as const
